<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		AdvancedCard,
		AdvancedCardV2,
		CardStatusBar,
		Container,
		LabelList,
		Modal,
		Select,
		Stack,
		Tab,
		Tabs,
		Text,
		Token,
		WidgetCard,
		PreviewBox,
		Label,
		LabelV2,
		Button,
		Input,
		CardGrid,
		ListNumberCard,
		IconButton,
		Alert,
		toast,
		LabelListV2,
		CardStatusBarV2,
	} from '@Shelly/shelly-design-system';
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { is1LWithMultipleInputs, real_id } from 'src/helpers/interface_helpers';
	import { status_configurator } from 'src/helpers/device_data_helpers';
	import { classMap } from '@Shelly/shelly-design-system/helpers/component-utils';
	import { capFirstChar, getErrorOrInfoMessageForMinAndMax } from 'src/helpers/utilities';
	import { onMount } from 'svelte';
	import MainControlStatusSlot from 'src/components/Lists/Devices/MainControlStatusSlot.svelte';
	import InputsReaderVisualizer from 'src/components/Controls/Indicators/InputsReaderVisualizer.svelte';
	import { requestEditSharedDevice } from 'src/components/Lists/list-helpers';
	import type { FormattedItemType } from './customize-device-wizard-helpers';
	import {
		checkIfHasValue,
		existsInLabelList,
		formatDataForDB,
		getHasNoAction,
		getLabelListFromDndItems,
		getSelectOptions,
		normalizeParams,
		resetCustomizeDeviceCard,
		setCorrectOrderForParams,
	} from './customize-device-wizard-helpers';
	import { bulkUpdate } from '../ApplicationSettings/app_settings_helper';
	import { inputStates } from 'src/stores/features/input-states';
	import { mappedInputReaderEvent } from 'src/helpers/input_reader_helpers';
	import { getDeviceStatusNameTrans } from 'src/helpers/name_translations_helper';
	import { getNumberInputConfig } from 'src/helpers/number_input_helpers';
	import {
		DECIMAL_PRECISION_MIN,
		DECIMAL_PRECISION_MAX,
	} from 'src/helpers/virtual_helpers/virtual_components_status_helpers';
	import { isVirtualDevice } from 'src/helpers/virtual_helpers/virtual_components_helpers';

	export let showModal = false;
	export let device;

	let activeTabIndex = 0;
	let bigParamSlotType = 'none';
	let dragDisabled = true;
	let selectedParameterTypeOption = {
		icon: '',
		iconStyle: '',
		title: '',
		value: '',
		name: '',
	};
	let hideSmallParamSlot = false;
	let selectParameterOptions = [];
	let previewLabelList = [];
	let decimalPrecisionInput = '1';
	// Mapped data arrays
	let mappedLabelListData = [];
	// Dnd arrays
	let selectedLabelListItemsDnd = [];
	let notSelectedLabelListItemsDnd = [];

	const flipDurationMs = 0;

	const tabItems = [
		{ text: $format('big_parameter_slot') },
		{ text: $format('small_parameter_slot') },
	];

	const slotContent = [
		{ title: 'none', type: 'none' },
		{ title: 'action', type: 'action' },
		{ title: 'parameter', type: 'param' },
	];

	const onClose = () => {
		getInitialData();

		showModal = false;
	};

	const clearMainPropsOfItems = () => {
		selectedLabelListItemsDnd.forEach((item) => {
			if (item.data.main) {
				delete item.data.main;
			}
		});

		notSelectedLabelListItemsDnd.forEach((item) => {
			if (item.data.main) {
				delete item.data.main;
			}
		});
	};

	const setMainProp = () => {
		const indexSelectedItems = selectedLabelListItemsDnd.findIndex(
			(item) => item.data.name === selectedParameterTypeOption?.name,
		);

		const indexNotSelectedItems = notSelectedLabelListItemsDnd.findIndex(
			(item) => item.data.name === selectedParameterTypeOption?.name,
		);

		if (indexSelectedItems !== -1) {
			clearMainPropsOfItems();
			selectedLabelListItemsDnd[indexSelectedItems].data.main = true;
		} else if (indexNotSelectedItems !== -1) {
			clearMainPropsOfItems();
			notSelectedLabelListItemsDnd[indexNotSelectedItems].data.main = true;
		}
	};

	const onChangeParameterType = (e: CustomEvent) => {
		selectedParameterTypeOption = e.detail;
		setMainProp();
	};

	const getSelectParameterOption = (selectParameterOptions) => {
		if (statusLabelParam) {
			const mainParam = statusLabelParam.find((item) => item.m);

			if (mainParam) {
				const index = selectParameterOptions.findIndex((item) => item.name === mainParam.n);

				if (index !== -1) {
					return selectParameterOptions[index];
				}
			}
		}

		if (hasNoAction && isInputsReader) {
			return {
				name: 'click combinations',
				title: capFirstChar(`${getDeviceStatusNameTrans('click combinations')}`),
				value:
					mappedInputReaderEvent[$inputStates?.[device.id]?.event] !== undefined ? '' : 'N/A',
				icon: 'fas fa-hand-back-point-up',
			};
		} else if (hasNoAction && !isInputsReader && mainStatusEl) {
			return {
				...mainStatusEl,
				title: capFirstChar(
					`${getDeviceStatusNameTrans(mainStatusEl.name, mainStatusEl)} ${mainStatusEl.value}`,
				),
			};
		} else {
			return selectParameterOptions[0];
		}
	};

	const mapLabelListData = (statuses, labelList) => {
		let mappedLabelListData = statuses
			.filter((i) => !i.hideLabel)
			.map((item) => {
				const isVisible = existsInLabelList(item, labelList);

				const newItem = {
					...item,
					visible: isVisible,
				};

				if (isVisible && newItem.main) {
					newItem.main = true;
				}

				return newItem;
			});

		if (statusLabelParam) {
			statusLabelParam.forEach((item) => {
				const matchingItem = mappedLabelListData.find((item2) => item2.name === item.n);

				if (!matchingItem && item.n === 'click combinations') {
					// Adding Param For Input Reader
					mappedLabelListData.push({
						name: item.n,
						value:
							mappedInputReaderEvent[$inputStates?.[device.id]?.event] !== undefined
								? ''
								: 'N/A',
						icon: 'fas fa-hand-back-point-up',
						order: item.o,
						main: item.m || false,
						visible: item.v,
						dotsType:
							mappedInputReaderEvent[$inputStates?.[device.id]?.event] !== undefined
								? mappedInputReaderEvent[$inputStates?.[device.id]?.event]
								: 'N/A',
					});
				} else if (matchingItem) {
					matchingItem.order = item.o;

					if (item.m) {
						matchingItem.main = true;
					} else {
						delete matchingItem.main;
					}

					if (item.v === true) {
						matchingItem.visible = true;
					} else if (item.v === false) {
						matchingItem.visible = false;
					}
				}
			});

			mappedLabelListData = mappedLabelListData.sort((a, b) => a.order - b.order);

			// Handle case where there are statuses added after we have saved  statusLabelParam for device and the new statuses are not found in statusLabelParam in device

			const statusesToAdd = statuses.filter(
				(item2) => !statusLabelParam.some((item1) => item1.n === item2.name),
			);

			if (statusesToAdd.length > 0) {
				statusesToAdd.forEach((status, i) => {
					const index = mappedLabelListData.findIndex((item) => item.name === status.name);

					if (index !== -1) {
						mappedLabelListData.splice(index, 1);
						status.visible = status.advLabel !== true;
						mappedLabelListData.push(status);
					}
				});

				mappedLabelListData.forEach((item, index) => {
					item.order = index + 1;
				});
			}
		}

		return mappedLabelListData;
	};

	const transformDraggedElement = (draggedEl: HTMLElement) => {
		// Visual only — svelte-dnd-action owns focus / keyboard a11y.
		const child = draggedEl.firstElementChild as HTMLElement | null;
		if (!child) return;
		child.setAttribute('tabIndex', '-1');
		child.classList.add('on-drag');
	};

	function handleSortSelected(e: CustomEvent) {
		selectedLabelListItemsDnd = e.detail.items;
		setCorrectOrderForParams(true, selectedLabelListItemsDnd);

		dragDisabled = true;
	}

	function handleSortAdditional(e: CustomEvent) {
		notSelectedLabelListItemsDnd = e.detail.items;
		setCorrectOrderForParams(false, notSelectedLabelListItemsDnd);

		dragDisabled = true;
	}

	const dndHandleClick = (e: MouseEvent | TouchEvent) => {
		const button = e.currentTarget as HTMLElement;
		button.classList.toggle('dnd-handle-drag');
	};

	const handleStartDrag = (e: MouseEvent | TouchEvent) => {
		dndHandleClick(e);
		dragDisabled = false;
	};

	const handleEndDrag = (e: TouchEvent | MouseEvent) => {
		dndHandleClick(e);
		dragDisabled = true;
	};

	const onRemoveParam = (paramID: string) => {
		const paramToRemove = [...selectedLabelListItemsDnd].find((item) => item.id === paramID);

		selectedLabelListItemsDnd = selectedLabelListItemsDnd.filter((item) => item.id !== paramID);

		notSelectedLabelListItemsDnd = [...notSelectedLabelListItemsDnd, paramToRemove];

		setCorrectOrderForParams(true, selectedLabelListItemsDnd);
		setCorrectOrderForParams(false, notSelectedLabelListItemsDnd);
	};

	const onAddParam = (paramID: string) => {
		const itemToAdd = [...notSelectedLabelListItemsDnd].find((item) => item.id === paramID);

		notSelectedLabelListItemsDnd = notSelectedLabelListItemsDnd.filter(
			(item) => item.id !== paramID,
		);

		selectedLabelListItemsDnd = [...selectedLabelListItemsDnd, itemToAdd];

		setCorrectOrderForParams(true, selectedLabelListItemsDnd);
		setCorrectOrderForParams(false, notSelectedLabelListItemsDnd);
	};

	const getSlotContent = (statuses, hasNoAction) => {
		if (hasNoAction) {
			return slotContent.filter((item) => item.type !== 'action');
		} else if (
			statuses.filter((i) => !i.hideLabel).length === 0 &&
			!mappedLabelListData.find((item) => item.name === 'click combinations') &&
			!isInputsReader
		) {
			return slotContent.filter((item) => item.type !== 'param');
		} else {
			return slotContent;
		}
	};

	const onSaveButton = async () => {
		const notSelectedItems = getLabelListFromDndItems(notSelectedLabelListItemsDnd);

		const visibleItemsFormatted = formatDataForDB(previewLabelList);
		const notVisibleItemsFormatted = formatDataForDB(notSelectedItems);

		const deviceParams: {
			statusLabelParam: FormattedItemType[];
			mainActionType: string;
			virtualDecimalPrecision?: number;
		} = {
			mainActionType: bigParamSlotType,
			statusLabelParam: [...visibleItemsFormatted, ...notVisibleItemsFormatted],
		};
		if (deviceIsVirtual && !hasPrecisionError) {
			deviceParams.virtualDecimalPrecision = Number(decimalPrecisionInput);
		}

		if (device.shared) {
			await requestEditSharedDevice({ ...device, ...deviceParams });
		} else {
			await bulkUpdate(device.id, { ...device, ...deviceParams });
		}

		toast.open({
			type: 'success',
			title: $format('device_card_customization_applied', {
				default: 'Device card customization applied successfully.',
			}),
			isTitleBold: true,
		});

		onClose();
	};

	const onResetButton = async () => {
		await resetCustomizeDeviceCard(device);
		toast.open({
			type: 'success',
			title: $format('device_card_customization_applied', {
				default: 'Device card customization applied successfully.',
			}),
			isTitleBold: true,
		});

		onClose();
	};

	const getInitialData = () => {
		activeTabIndex = 0;
		let visibleItems = [];
		let notVisibleItems = [];

		if (!statusLabelParam) {
			let filteredVisibleItems = mappedLabelListData.filter((item) => item.visible);
			let filteredNotVisibleItems = mappedLabelListData.filter((item) => !item.visible);

			// Set order here
			visibleItems = filteredVisibleItems.map((item, index) => ({
				...item,
				order: index + 1,
			}));

			notVisibleItems = filteredNotVisibleItems.map((item, index) => ({
				...item,
				order: index + 1,
			}));
		} else {
			visibleItems = mappedLabelListData.filter((item) => item.visible);
			notVisibleItems = mappedLabelListData.filter((item) => !item.visible);
		}

		selectedLabelListItemsDnd = visibleItems.map((item) => ({
			id: item.name,
			isDndShadowItem: false,
			data: { ...item },
		}));

		notSelectedLabelListItemsDnd = notVisibleItems.map((item) => ({
			id: item.name,
			isDndShadowItem: false,
			data: { ...item },
		}));

		// Create inputs reader param in not visible data if there is not one added yet
		if (!mappedLabelListData.find((item) => item.name === 'click combinations') && isInputsReader) {
			notSelectedLabelListItemsDnd.push({
				id: 'click combinations',
				isDndShadowItem: false,
				data: {
					name: 'click combinations',
					value:
						mappedInputReaderEvent[$inputStates?.[device.id]?.event] !== undefined
							? ''
							: 'N/A',
					icon: 'fas fa-hand-back-point-up',
					dotsType: mappedInputReaderEvent[$inputStates?.[device.id]?.event],
					visible: false,
					order: notSelectedLabelListItemsDnd.length + 1,
				},
			});
		}

		selectParameterOptions = getSelectOptions(statuses, isInputsReader, device, $inputStates);
		selectedParameterTypeOption = getSelectParameterOption(selectParameterOptions);

		if (
			(hasNoAction && !statusLabelParam && !mainStatusEl && !isInputsReader) ||
			device?.mainActionType === 'none'
		) {
			bigParamSlotType = 'none';
		} else if (hasNoAction) {
			bigParamSlotType = 'param';
		} else if (device.mainActionType) {
			bigParamSlotType = device.mainActionType;
		} else {
			bigParamSlotType = 'action';
		}
		decimalPrecisionInput = String(device?.virtualDecimalPrecision ?? DECIMAL_PRECISION_MIN);
	};

	$: parsedDecimal = Number(decimalPrecisionInput);

	$: decimalPrecisionValue = Number.isInteger(parsedDecimal) ? parsedDecimal : NaN;
	$: deviceIsVirtual = isVirtualDevice(device?.type);
	$: decimalPrecisionInputData = deviceIsVirtual
		? getErrorOrInfoMessageForMinAndMax(
				decimalPrecisionValue,
				DECIMAL_PRECISION_MIN,
				DECIMAL_PRECISION_MAX,
			)
		: { error: '', info: '' };
	$: hasPrecisionError = deviceIsVirtual && Boolean(decimalPrecisionInputData.error);
	$: virtualPrecision = deviceIsVirtual
		? Number(device?.virtualDecimalPrecision ?? DECIMAL_PRECISION_MIN)
		: undefined;
	$: resolvedDecimalPrecision =
		deviceIsVirtual && !hasPrecisionError ? Number(decimalPrecisionInput) : virtualPrecision;
	$: previewDevice = deviceIsVirtual
		? { ...device, virtualDecimalPrecision: resolvedDecimalPrecision }
		: device;

	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	$: statuses = status_configurator(status, previewDevice, settings, true);
	$: labelList = statuses.filter(
		(label) =>
			'undefined' === typeof label.main &&
			!label.hideLabel &&
			!label.advLabel &&
			!/^(timer|schedule|last)$/.test(label.name),
	);
	// Used for conditions
	$: isInputsReader =
		device.category === 'inputs_reader' ||
		(device.category === 'module' && device.mode === 'inputs_reader');
	$: mainStatusEl = statuses.find((el) => el.main === true);
	$: hasNoAction = getHasNoAction(device, statuses);
	$: slotContentFiltered = getSlotContent(statuses, hasNoAction);
	$: isTabBigParams = activeTabIndex === 0;
	$: isTabSmallParams = activeTabIndex === 1;
	$: hideSmallParamSlot = previewLabelList.length === 0;
	$: hideBigParamSlot = bigParamSlotType === 'none';
	// Set data
	$: statusLabelParam = normalizeParams(device?.statusLabelParam);
	$: mappedLabelListData = mapLabelListData(statuses, labelList);
	$: {
		if (bigParamSlotType === 'param') {
			setMainProp();
		}

		previewLabelList = getLabelListFromDndItems(selectedLabelListItemsDnd);

		statuses.forEach((status) => {
			previewLabelList = getLabelListFromDndItems(selectedLabelListItemsDnd);

			const indexPreviewLabelList = previewLabelList.findIndex((item) => {
				if (item.name === status.name) {
					return item;
				}
			});

			const indexSelectParameter = selectParameterOptions.findIndex((item) => {
				if (item.name === status.name) {
					return item;
				}
			});

			const indexSelectedLabelListItems = selectedLabelListItemsDnd.findIndex((item) => {
				if (item.data.name === status.name) {
					return item;
				}
			});

			const indexNotSelectedLabelListItems = notSelectedLabelListItemsDnd.findIndex((item) => {
				if (item.data.name === status.name) {
					return item;
				}
			});

			if (indexSelectedLabelListItems !== -1) {
				selectedLabelListItemsDnd[indexSelectedLabelListItems].data.value = checkIfHasValue(
					status.value,
				);
			}

			if (indexNotSelectedLabelListItems !== -1) {
				notSelectedLabelListItemsDnd[indexNotSelectedLabelListItems].data.value =
					checkIfHasValue(status.value);
			}

			if (indexPreviewLabelList !== -1) {
				previewLabelList[indexSelectedLabelListItems].value = checkIfHasValue(status.value);
			}

			if (indexSelectParameter !== -1) {
				selectParameterOptions[indexSelectParameter].value = checkIfHasValue(status.value);
			}

			if (selectedParameterTypeOption?.name === status.name) {
				selectedParameterTypeOption.value = checkIfHasValue(status.value);
				const translatedStatusName = getDeviceStatusNameTrans(
					selectedParameterTypeOption.name,
					selectedParameterTypeOption,
				);
				if (selectedParameterTypeOption.value) {
					selectedParameterTypeOption.title = capFirstChar(
						is1LWithMultipleInputs(device?.type)
							? translatedStatusName
								? `${translatedStatusName}:`
								: selectedParameterTypeOption.value.toString()
							: `${translatedStatusName}: ${selectedParameterTypeOption.value.toString()}`,
					);
				} else {
					selectedParameterTypeOption.title = capFirstChar(translatedStatusName);
				}
			}
		});
	}

	onMount(() => {
		getInitialData();
	});
</script>

<Modal
	on:close={onClose}
	title={$format('title_customize_device_card', {
		default: 'Customize device card',
	})}
	{showModal}
	removeScrollPadding
>
	<Container slot="content" padding="scrollPaddings">
		{#if mappedLabelListData.length > 0 || notSelectedLabelListItemsDnd.length > 0 || selectedLabelListItemsDnd.length > 0}
			<Tabs class="mb-sm-m mb-md-l">
				{#each tabItems as item, i}
					<Tab
						active={i === activeTabIndex}
						on:click={() => {
							activeTabIndex = i;
						}}
					>
						{$format(item.text)}
					</Tab>
				{/each}
			</Tabs>
		{/if}

		{#if activeTabIndex === 0}
			<Text element="h2" class="mb-s">
				{$format('choose_slot_content', {
					default: 'Choose slot content',
				})}
			</Text>
			<div class="d-flex flex-wrap">
				{#each slotContentFiltered as content, i}
					<Token
						id="token-t3q2puu"
						size="m"
						class={classMap({ 'mr-s': i !== slotContentFiltered.length - 1, 'mb-s': true })}
						selected={bigParamSlotType === content.type}
						title={capFirstChar($format(content.title))}
						on:click={() => {
							bigParamSlotType = content.type;

							if (bigParamSlotType === 'param') {
								setMainProp();
							} else {
								clearMainPropsOfItems();
							}
						}}
					/>
				{/each}
				<Button
					variant="danger"
					class="ml-s mb-s"
					style="border-radius: var(--radius-extra-big);"
					size="m"
					on:click={onResetButton}
				>
					{capFirstChar($format('button_reset', { default: 'Reset' }))}
				</Button>
			</div>

			{#if bigParamSlotType === 'param'}
				<Text class="mb-s mt-s text-bold" styleType="body-small">
					{$format('parameter_type', {
						default: 'Parameter type',
					})}
				</Text>
				<Select
					class="mb-s"
					icon={null}
					value={selectedParameterTypeOption}
					on:change={onChangeParameterType}
					options={selectParameterOptions}
					label="Alternative Select without icon"
					id="select-cxtyo1z"
					aria-labelledby="select-cxtyo1z"
				/>
			{/if}

			{#if deviceIsVirtual}
				<Text class="mb-s mt-s text-bold" styleType="body-small">
					{$format('decimal_precision', {
						default: 'Decimal precision',
					})}
				</Text>
				<Input
					{...getNumberInputConfig()}
					id="input-virtual-decimal-precision"
					icon="fas fa-calculator"
					bind:value={decimalPrecisionInput}
					step={1}
					error={decimalPrecisionInputData.error}
					info={decimalPrecisionInputData.info}
					aria-label={$format('decimal_precision', {
						default: 'Decimal precision',
					})}
				/>
			{/if}
		{/if}

		{#if activeTabIndex === 1}
			<Text element="h2" class="mb-s">
				{$format('select_params', {
					default: 'Selected Parameters',
				})}
			</Text>

			<CardGrid
				dndSettings={{
					items: selectedLabelListItemsDnd,
					flipDurationMs: flipDurationMs,
					dragDisabled: dragDisabled,
					transformDraggedElement,
					type: 'params',
				}}
				on:consider={handleSortSelected}
				on:finalize={handleSortSelected}
				class="mb-l"
				widthUnit="%"
				sm={100}
				gridGap="s"
				gridRowMinContent
				gridStyledDndZone
				gridStyledDndZoneText={$format('drag_and_drop_your_additional_params', {
					default: 'Drop your additional parameters here.',
				})}
			>
				{#each selectedLabelListItemsDnd as content, i (content?.id)}
					<div class:dnd-placeholder={content.isDndShadowItem}>
						<ListNumberCard size="s" cardNumber={i + 1 >= 10 ? i + 1 : `0${i + 1}`} editMode>
							<IconButton
								aria-label={$format('button_drag_and_drop_handle', {
									default: 'Button Drag and drop handle',
								})}
								icon="fas fa-up-down-left-right"
								dndHandle
								class="mr-s"
								on:mousedown={handleStartDrag}
								on:touchstart={handleStartDrag}
								on:mouseup={handleEndDrag}
								on:touchend={handleEndDrag}
							/>
							<Text class="width-full" noWrap styleType="body-small">
								{@const translatedStatusName = getDeviceStatusNameTrans(
									content.data.name,
									content.data,
								)}
								{capFirstChar(translatedStatusName)}
								{translatedStatusName && content.data.value ? ':' : ''}
								{content.data.value}
							</Text>
							<IconButton
								aria-label={$format('button_remove_parameter', {
									default: 'Button Remove parameter',
								})}
								class="ml-s"
								icon="fas fa-minus"
								variant="danger"
								on:click={() => onRemoveParam(content.id)}
							/>
						</ListNumberCard>
					</div>
				{/each}
			</CardGrid>

			<Text class="mb-s" styleType="h2">
				{$format('additional_params', {
					default: 'Additional parameters',
				})}
			</Text>

			<CardGrid
				dndSettings={{
					items: notSelectedLabelListItemsDnd,
					flipDurationMs: flipDurationMs,
					dragDisabled: dragDisabled,
					transformDraggedElement,
					type: 'params',
				}}
				on:consider={handleSortAdditional}
				on:finalize={handleSortAdditional}
				widthUnit="%"
				sm={100}
				gridGap="s"
				title="Test title"
				gridRowMinContent
			>
				{#if notSelectedLabelListItemsDnd.length === 0}
					<Alert
						heading={$format('list_of_avl_params_empty', {
							default:
								'The list of available parameters is empty since all options are currently selected.',
						})}
					/>
				{/if}
				{#each notSelectedLabelListItemsDnd as content, i (content.id)}
					<div class:dnd-placeholder={content.isDndShadowItem}>
						<ListNumberCard editMode size="s">
							<IconButton
								aria-label={$format('button_drag_and_drop_handle', {
									default: 'Button Drag and drop handle',
								})}
								on:mousedown={handleStartDrag}
								on:touchstart={handleStartDrag}
								on:mouseup={handleEndDrag}
								on:touchend={handleEndDrag}
								icon="fas fa-up-down-left-right"
								dndHandle
								class="mr-s"
							/>
							<Text class="width-full" noWrap styleType="body-small">
								{@const translatedStatusName = getDeviceStatusNameTrans(
									content.data.name,
									content.data,
								)}
								{capFirstChar(translatedStatusName)}
								{translatedStatusName && content.data.value ? ':' : ''}
								{content.data.value}
							</Text>
							<IconButton
								aria-label={$format('button_add_parameter', {
									default: 'Button Add parameter',
								})}
								class="ml-s"
								icon="fas fa-plus"
								variant="success"
								on:click={() => onAddParam(content.id)}
							/>
						</ListNumberCard>
					</div>
				{/each}
			</CardGrid>
		{/if}

		<Text class="mb-s mt-md-m mt-sm-s" styleType="h2"
			>{$format('schedules_wizard_items_preview')}</Text
		>

		<PreviewBox backgroundImageSrc="./images/loginBackground.png">
			<Stack
				gap="m"
				direction="column"
				directionMobile="row"
				class={classMap({
					'width-full align-items-center': true,
					'justify-content-center': $showNewLayout,
				})}
			>
				{#if !$showNewLayout}
					<WidgetCard
						class="width-m justify-self-center"
						title={$format('label_custom_dash_heading')}
						subtitle={{
							value: $format('label_custom_dash_subheading'),
						}}
						avatar={{ icon: 'fas fa-mountain-sun text-color-3' }}
						previewMode
						previewModeHighlightBottom={isTabBigParams}
						previewModeHighlightMain={activeTabIndex === 1}
						hideSlotBottom={hideBigParamSlot}
						hideSlotMain={hideSmallParamSlot}
					>
						<LabelList size="m" slot="main" labelList={previewLabelList} />

						<svelte:fragment slot="bottom">
							{#if bigParamSlotType === 'action'}
								<MainControlStatusSlot
									inPreivew
									device={previewDevice}
									{status}
									{settings}
									{statuses}
								/>
							{:else if bigParamSlotType === 'param' && selectedParameterTypeOption?.title === 'Click combinations'}
								<InputsReaderVisualizer showLabel {device} {status} {settings} />
							{:else}
								<Label
									style="max-width: 100%;"
									size="xl"
									icon={selectedParameterTypeOption?.icon}
									iconStyle={selectedParameterTypeOption?.iconStyle}
									value={selectedParameterTypeOption?.value}
								/>
							{/if}
						</svelte:fragment>
					</WidgetCard>
				{/if}

				{#if $showNewLayout}
					<div style="width: 340px;">
						<AdvancedCardV2
							title={$format('label_custom_dash_heading')}
							avatar={{
								icon: 'fas fa-mountain-sun text-color-3',
								backgroundColor: 'color-base',
							}}
							previewMode
							previewModeHighlightRight={isTabBigParams}
							previewModeHighlightMain={isTabSmallParams}
							hideSlotRight={hideBigParamSlot}
							hideSlotMain={hideSmallParamSlot}
						>
							<CardStatusBarV2
								statsList={[
									{ icon: 'fas fa-circle' },
									{ icon: 'fas fa-circle' },
									{ icon: 'fas fa-circle' },
								]}
								slot="statusBar"
							/>

							<LabelListV2
								a11yProps={{ isInteractive: false }}
								size="m"
								labelList={previewLabelList}
								slot="main"
							/>

							<svelte:fragment slot="right">
								{#if bigParamSlotType === 'action'}
									<MainControlStatusSlot
										useV2Components={true}
										devBtnsV2Props={{
											deviceButtonV2: { size: 'm' },
											doubleDeviceButtonV2: { size: 'm' },
											tripleDeviceButtonV2: { size: 'm' },
										}}
										inPreivew
										device={previewDevice}
										{status}
										{settings}
										{statuses}
									/>
								{:else if bigParamSlotType === 'param' && selectedParameterTypeOption?.title === 'Click combinations'}
									<InputsReaderVisualizer
										useV2Components={true}
										showLabel
										{device}
										{status}
										{settings}
									/>
								{:else}
									<LabelV2
										size="l"
										icon={selectedParameterTypeOption?.icon}
										iconStyle={selectedParameterTypeOption?.iconStyle}
										value={selectedParameterTypeOption?.value}
									/>
								{/if}
							</svelte:fragment>
						</AdvancedCardV2>
					</div>
				{:else}
					<AdvancedCard
						title={$format('label_custom_dash_heading')}
						avatar={{ icon: 'fas fa-mountain-sun text-color-3' }}
						previewMode
						previewModeHighlightRight={isTabBigParams}
						previewModeHighlightMain={activeTabIndex === 1}
						hideSlotRight={hideBigParamSlot}
						hideSlotMain={hideSmallParamSlot}
					>
						<CardStatusBar
							statsList={[
								{ icon: 'fas fa-circle' },
								{ icon: 'fas fa-circle' },
								{ icon: 'fas fa-circle' },
							]}
							slot="statusBar"
						/>

						<LabelList size="m" labelList={previewLabelList} slot="main" />

						<svelte:fragment slot="right">
							{#if bigParamSlotType === 'action'}
								<MainControlStatusSlot
									inPreivew
									device={previewDevice}
									{status}
									{settings}
									{statuses}
								/>
							{:else if bigParamSlotType === 'param' && selectedParameterTypeOption?.title === 'Click combinations'}
								<InputsReaderVisualizer showLabel {device} {status} {settings} />
							{:else}
								<Label
									size="l"
									icon={selectedParameterTypeOption?.icon}
									iconStyle={selectedParameterTypeOption?.iconStyle}
									value={selectedParameterTypeOption?.value}
								/>
							{/if}
						</svelte:fragment>
					</AdvancedCard>
				{/if}
			</Stack>
		</PreviewBox>
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			variant="secondary"
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={() => (showModal = false)}
		>
			{$format('button_cancel')}
		</Button>
		<Button
			on:click={onSaveButton}
			disabled={hasPrecisionError}
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
		>
			{$format('button_save')}
		</Button>
	</div>
</Modal>
